export const samsungStore =
  'samsungapps://ProductDetail/com.epicgames.portal?form=popup&custom=true&directOpen=true&source=webbrowser_epic';
export const appleStore = 'https://AppStore.com/app/fortnite/id1261357853?mt=8';
